import { InjectionToken } from "@angular/core";

export const USERFILTER_FORMGROUP = new InjectionToken('USERFILTER_FORMGROUP');
export const SHARE_WITH_CUSTOMERS = new InjectionToken('SHARE_WITH_CUSTOMERS');
